module.exports = "/_next/static/images/edgeDataCenters-78d607d9395b5eac0d60d5adf4285d03.webp";